const X_HOSTNAMES = new Set([
  'x.com',
  'www.x.com',
  'mobile.x.com',
  'twitter.com',
  'www.twitter.com',
  'mobile.twitter.com',
]);

export function canonicalXPostUrl(value) {
  try {
    const url = new URL(value);
    const match = url.pathname.match(/^\/([A-Za-z0-9_]+)\/status\/(\d+)\/?$/);
    if (url.protocol !== 'https:' || url.username || url.password || !X_HOSTNAMES.has(url.hostname.toLowerCase()) || !match) return null;
    return `https://x.com/${match[1]}/status/${match[2]}`;
  } catch {
    return null;
  }
}

/**
 * 只有 X / Twitter 帖子属于允许公开展示的外部媒体来源。
 * 对标网站的 URL 可以继续作为内部素材溯源数据，但不能渲染成站外链接。
 */
export function isXSourceUrl(value = '') {
  if (!value) return false;

  try {
    return X_HOSTNAMES.has(new URL(value).hostname.toLowerCase());
  } catch {
    return false;
  }
}
